export type CarMake = {
  id: string;
  name_ar: string;
  name_en: string;
  country_group: 'japanese' | 'korean' | 'german' | 'others';
  logo_url: string;
  is_active: boolean;
  sort_order: number;
};

export type CarModel = {
  id: string;
  make_id: string;
  name_ar: string;
  name_en: string;
  is_active: boolean;
  sort_order: number;
};

export type Listing = {
  id: string;
  title: string;
  price: number;
  year: number;
  make_id: string;
  model_id: string;
  fuel_type?: string;
  transmission?: string;
  description: string;
  image_url: string;
  created_at: string;
};

export type Part = {
  id: string;
  name_ar: string;
  category: string;
  price: number;
  image_url: string;
  brand: string;
  rating: number;
  sku?: string;
};

export const MOCK_CAR_MAKES: CarMake[] = [
  { id: 'toyota', name_ar: 'تويوتا', name_en: 'Toyota', country_group: 'japanese', logo_url: '/assets/car_brands/toyota.svg', is_active: true, sort_order: 1 },
  { id: 'hyundai', name_ar: 'هيونداي', name_en: 'Hyundai', country_group: 'korean', logo_url: '/assets/car_brands/hyundai.svg', is_active: true, sort_order: 2 },
  { id: 'mercedes', name_ar: 'مرسيدس بنز', name_en: 'Mercedes-Benz', country_group: 'german', logo_url: '/assets/car_brands/mercedes.png', is_active: true, sort_order: 3 },
  { id: 'bmw', name_ar: 'بي إم دبليو', name_en: 'BMW', country_group: 'german', logo_url: '/assets/car_brands/bmw.png', is_active: true, sort_order: 4 },
  { id: 'nissan', name_ar: 'نيسان', name_en: 'Nissan', country_group: 'japanese', logo_url: '/assets/car_brands/nissan.png', is_active: true, sort_order: 5 },
  { id: 'kia', name_ar: 'كيا', name_en: 'Kia', country_group: 'korean', logo_url: '/assets/car_brands/kia.png', is_active: true, sort_order: 6 },
  { id: 'lexus', name_ar: 'لكزس', name_en: 'Lexus', country_group: 'japanese', logo_url: '/assets/car_brands/lexus.svg', is_active: true, sort_order: 7 },
  { id: 'ford', name_ar: 'فورد', name_en: 'Ford', country_group: 'others', logo_url: '/assets/car_brands/ford.png', is_active: true, sort_order: 8 },
  { id: 'honda', name_ar: 'هوندا', name_en: 'Honda', country_group: 'japanese', logo_url: '/assets/car_brands/honda.png', is_active: true, sort_order: 9 },
  { id: 'tesla', name_ar: 'تسلا', name_en: 'Tesla', country_group: 'others', logo_url: '/assets/car_brands/tesla.png', is_active: true, sort_order: 10 },
  { id: 'audi', name_ar: 'أودي', name_en: 'Audi', country_group: 'german', logo_url: '/assets/car_brands/audi.png', is_active: true, sort_order: 11 },
  { id: 'volkswagen', name_ar: 'فولكس واجن', name_en: 'Volkswagen', country_group: 'german', logo_url: '/assets/car_brands/volkswagen.png', is_active: true, sort_order: 12 },
  { id: 'chevrolet', name_ar: 'شيفروليه', name_en: 'Chevrolet', country_group: 'others', logo_url: '/assets/car_brands/chevrolet.png', is_active: true, sort_order: 13 },
  { id: 'mazda', name_ar: 'مازدا', name_en: 'Mazda', country_group: 'japanese', logo_url: '/assets/car_brands/mazda.png', is_active: true, sort_order: 14 },
  { id: 'porsche', name_ar: 'بورشه', name_en: 'Porsche', country_group: 'german', logo_url: '/assets/car_brands/porsche.png', is_active: true, sort_order: 15 },
  { id: 'landrover', name_ar: 'لاند روفر', name_en: 'Land Rover', country_group: 'others', logo_url: '/assets/car_brands/landrover.png', is_active: true, sort_order: 16 },
  { id: 'jeep', name_ar: 'جيب', name_en: 'Jeep', country_group: 'others', logo_url: '/assets/car_brands/jeep.png', is_active: true, sort_order: 17 },
  { id: 'gmc', name_ar: 'جي إم سي', name_en: 'GMC', country_group: 'others', logo_url: '/assets/car_brands/gmc.png', is_active: true, sort_order: 18 },
  { id: 'volvo', name_ar: 'فولفو', name_en: 'Volvo', country_group: 'others', logo_url: '/assets/car_brands/volvo.png', is_active: true, sort_order: 19 },
  { id: 'subaru', name_ar: 'سوبارو', name_en: 'Subaru', country_group: 'japanese', logo_url: '/assets/car_brands/subaru.png', is_active: true, sort_order: 20 },
  { id: 'jaguar', name_ar: 'جاكوار', name_en: 'Jaguar', country_group: 'others', logo_url: '/assets/car_brands/jaguar.png', is_active: true, sort_order: 21 },
  { id: 'infiniti', name_ar: 'إنفينيتي', name_en: 'Infiniti', country_group: 'japanese', logo_url: '/assets/car_brands/infiniti.png', is_active: true, sort_order: 22 },
];

export const MOCK_CAR_MODELS: CarModel[] = [
  { id: 'camry', make_id: 'toyota', name_ar: 'كامري', name_en: 'Camry', is_active: true, sort_order: 1 },
  { id: 'corolla', make_id: 'toyota', name_ar: 'كورولا', name_en: 'Corolla', is_active: true, sort_order: 2 },
  { id: 'elantra', make_id: 'hyundai', name_ar: 'إلنترا', name_en: 'Elantra', is_active: true, sort_order: 1 },
  { id: 's-class', make_id: 'mercedes', name_ar: 'الفئة S', name_en: 'S-Class', is_active: true, sort_order: 1 },
  { id: 'land-cruiser', make_id: 'toyota', name_ar: 'لاندكروزر', name_en: 'Land Cruiser', is_active: true, sort_order: 3 },
  { id: '5-series', make_id: 'bmw', name_ar: 'الفئة الخامسة', name_en: '5 Series', is_active: true, sort_order: 1 },
  { id: 'accord', make_id: 'honda', name_ar: 'أكورد', name_en: 'Accord', is_active: true, sort_order: 1 },
  { id: 'model-3', make_id: 'tesla', name_ar: 'موديل 3', name_en: 'Model 3', is_active: true, sort_order: 1 },
  { id: 'mustang', make_id: 'ford', name_ar: 'موستانج', name_en: 'Mustang', is_active: true, sort_order: 1 },
  { id: 'cayenne', make_id: 'porsche', name_ar: 'كايين', name_en: 'Cayenne', is_active: true, sort_order: 1 },
];

export const MOCK_LISTINGS: Listing[] = [
  {
    id: 'l1',
    title: 'تويوتا كامري 2023 بحالة الوكالة',
    price: 95000,
    year: 2023,
    make_id: 'toyota',
    model_id: 'camry',
    description: 'سيارة نظيفة جداً، استخدام شخصي، صيانة دورية في الوكالة، خالية من الصدمات والرش، تواير جديدة ملكية سنة.',
    image_url: 'https://picsum.photos/seed/camry/600/400',
    created_at: new Date().toISOString(),
  },
  {
    id: 'l2',
    title: 'مرسيدس بنز S-Class 2022',
    price: 450000,
    year: 2022,
    make_id: 'mercedes',
    model_id: 's-class',
    description: 'كاملة المواصفات، فتحة سقف بانوراما، كراسي مساج، رادار، نقطة عمياء، استخدام راقي جداً.',
    image_url: 'https://picsum.photos/seed/sclass/600/400',
    created_at: new Date().toISOString(),
  },
  {
    id: 'l3',
    title: 'تويوتا كورولا 2021 فل كامل',
    price: 65000,
    year: 2021,
    make_id: 'toyota',
    model_id: 'corolla',
    description: 'اقتصادية جداً في الوقود، حالة ممتازة، شاشة، كاميرا خلفية، حساسات.',
    image_url: 'https://picsum.photos/seed/corolla/600/400',
    created_at: new Date().toISOString(),
  },
  {
    id: 'l4',
    title: 'هيونداي إلنترا 2020 ستاندر',
    price: 52000,
    year: 2020,
    make_id: 'hyundai',
    model_id: 'elantra',
    description: 'سيارة عملية جداً، مكينة وقير على الشرط، بودي بلد ماعدا حكات بسيطة.',
    image_url: 'https://picsum.photos/seed/elantra/600/400',
    created_at: new Date().toISOString(),
  },
  {
    id: 'l5',
    title: 'بي إم دبليو الفئة الخامسة 2024 أصفار',
    price: 280000,
    year: 2024,
    make_id: 'bmw',
    model_id: '5-series',
    description: 'جديدة بالكامل، ضمان الوكيل 5 سنوات، مواصفات خاصة، لون أسود ملكي.',
    image_url: 'https://picsum.photos/seed/bmw5/600/400',
    created_at: new Date().toISOString(),
  },
];

export const MOCK_PARTS: Part[] = [
  { id: 'p1', name_ar: 'فحمات فرامل أمامية', category: 'الفرامل', price: 250, image_url: 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=600', brand: 'Brembo', rating: 4.8, sku: 'BR-2024-F' },
  { id: 'p2', name_ar: 'فلتر زيت محرك', category: 'المحرك', price: 45, image_url: 'https://images.unsplash.com/photo-1635773054018-20835064619a?q=80&w=600', brand: 'Denso', rating: 4.5, sku: 'OIL-101' },
];

export const PART_CATEGORIES = ['المحرك', 'الفرامل', 'المساعدات', 'كهرباء', 'زيوت'];

export const APP_SETTINGS = {
  country_code: 'OM',
  country_name_ar: 'عُمان',
  currency_code: 'OMR',
  currency_symbol: 'ر.ع',
  currency_position: 'after',
  default_language: 'ar',
};
